import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const BlankCircleFilled: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      d="M15 .5C6.98545.5.5 6.99864.5 15c0 8.0014 6.48545 14.5 14.5 14.5 8.0145 0 14.5-6.4855 14.5-14.5C29.5 6.98545 23.0145.5 15 .5Z"
    />
  </Icon>
);
